import { useEffect, useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import { connect } from "react-redux";
import { general } from "../../../../../store/action";
import {
  isHideModalDataSelector,
  isShowModalDataSelector,
  modalDataSelector,
  modalNameSelector,
} from "../../../../../store/selector/general";
import {
  useSakhadGetSubHistory,
  useSakhadPrintPrescription,
} from "../../../../../hook/request/providerSakhad";
import Modal from "../../../general/modal";
import Icon from "../../../general/icon";
import EmptyBox from "../../../general/emptyBox";
import { PatientSakhadVisitTable_rowItem } from "./dataList/patientSakhadVisitTable_rowItem";

type ShowPatientSakhadVisitModalProps = {
  modalData: any;
  modalName: string;
  isShowModalData: boolean;
  handleHideModal: any;
  handleResetModal: any;
  handleShowModal: any;
};

type ModalInfoProps = {
  patientId?: any;
  uuid?: string;
  item?: any;
};

const ShowPatientSakhadVisitModal = ({
  modalData,
  modalName,
  isShowModalData,
  handleHideModal,
  handleResetModal,
}: ShowPatientSakhadVisitModalProps) => {
  const [showState, setShowState] = useState(false);
  const [modalInfo, setModalInfo] = useState<ModalInfoProps | null>(null);

  const getSakhadSubHistory = useSakhadGetSubHistory();
  const downloadPrescriptionFile = useSakhadPrintPrescription();

  useEffect(() => {
    if (isShowModalData && modalName === "showPatientSakhadVisitModal") {
      setShowState(true);
      setModalInfo(modalData);

      const requestBody = {
        nationalNumber: modalData?.patientId?.id
          ? String(modalData.patientId.id)
          : "",
        prescriptionUuid: modalData?.uuid,
      };

      if (
        modalData?.patientId !== undefined &&
        modalData?.uuid !== undefined &&
        modalData?.uuid !== null
      ) {
        getSakhadSubHistory.mutate(requestBody);
      }
      handleResetModal();
    }
  }, [modalData, modalName]);

  //   useEffect(() => {
  //     console.log("SAKHAD_09", getSakhadSubHistory.data);
  //   }, [getSakhadSubHistory.data]);

  const handleSetShowModal = () => {
    setShowState(false);
    handleHideModal();
  };

  // Logic to split the items based on terminology
  const rawList = getSakhadSubHistory?.data?.data?.result || [];
  const drugServices = rawList.filter(
    (item: any) => item.terminology === "ERX",
  );
  const paraclinicalServices = rawList.filter(
    (item: any) => item.terminology !== "ERX",
  );

  // Helper to render a specific section table
  const renderTableSection = (title: string, items: any[]) => {
    if (items.length === 0) return null;

    return (
      <div className="mb-5">
        <div className="bg-light-blue p-2 rounded mb-3 border-right-primary">
          <h5 className="font-14 font-weight-bold mb-0 text-primary px-2">
            {title}
          </h5>
        </div>
        <Table responsive striped hover className="custom-table border">
          <thead>
            <tr>
              <th>نام خدمت</th>
              <th>تواتر</th>
              <th>واحد</th>
              <th>تعداد</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item: any, index: number) => (
              <PatientSakhadVisitTable_rowItem key={index} item={item} />
            ))}
          </tbody>
        </Table>
      </div>
    );
  };

  return (
    <Modal
      setShow={handleSetShowModal}
      showState={showState}
      noCloseBtn={true}
      className="w-1000 mw-100"
      bodyClassName="px-3 px-lg-5 pos-rel"
    >
      <div className="form-box w-1000 mw-100 mx-auto py-3">
        {/* Header Section */}
        <div className="d-flex mb-4 fs-3 px-2 border-bottom pb-2">
          <div className="px-2 flex-fill align-content-center">
            <h4 className="d-flex align-items-center title-dot font-16 font-weight-bold">
              جزئیات نسخه
            </h4>
          </div>
          <span
            className="text-red-hover cur-pointer"
            onClick={handleSetShowModal}
          >
            <Icon name="close-square" />
          </span>
        </div>

        {/* Content Section */}
        <div className="px-2" style={{ minHeight: "300px" }}>
          {getSakhadSubHistory.isPending ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
              <p className="mt-2 font-12">در حال دریافت اطلاعات...</p>
            </div>
          ) : rawList.length > 0 ? (
            <>
              {renderTableSection("خدمات دارویی", drugServices)}
              <div className="d-flex justify-content-center align-items-center">
                <span
                  className="d-flex text-hover mx-2 font-20 cur-pointer"
                  onClick={() => {
                    const reqBody = {
                      nationalNumber: String(modalInfo?.patientId?.id),
                      trackingCode: String(modalInfo?.item?.sakhadTrackingCode),
                      tajvizType: "2",
                    };
                    downloadPrescriptionFile.mutate(reqBody);
                  }}
                >
                  <Icon name="file-download" />
                  <p className="d-flex text-hover mx-2 font-14 fw-semibold cur-pointer">
                    دانلود نسخه دارویی
                  </p>
                </span>
              </div>
              {renderTableSection("خدمات پاراکلینیکی", paraclinicalServices)}
              <div className="d-flex justify-content-center align-items-center">
                <span
                  className="d-flex text-hover mx-2 font-20 cur-pointer"
                  onClick={() => {
                    const reqBody = {
                      nationalNumber: String(modalInfo?.patientId?.id),
                      trackingCode: String(modalInfo?.item?.sakhadTrackingCode),
                      tajvizType: "3",
                    };
                    downloadPrescriptionFile.mutate(reqBody);
                  }}
                >
                  <Icon name="file-download" />
                  <p className="d-flex text-hover mx-2 font-14 fw-semibold cur-pointer">
                    دانلود نسخه آزمایش
                  </p>
                </span>
                <span
                  className="d-flex text-hover mx-2 font-20 cur-pointer"
                  onClick={() => {
                    const reqBody = {
                      nationalNumber: String(modalInfo?.patientId?.id),
                      trackingCode: String(modalInfo?.item?.sakhadTrackingCode),
                      tajvizType: "4",
                    };
                    downloadPrescriptionFile.mutate(reqBody);
                  }}
                >
                  <Icon name="file-download" />
                  <p className="d-flex text-hover mx-2 font-14 fw-semibold cur-pointer">
                    دانلود نسخه پرتوپزشکی
                  </p>
                </span>
                <span
                  className="d-flex text-hover mx-2 font-20 cur-pointer"
                  onClick={() => {
                    const reqBody = {
                      nationalNumber: String(modalInfo?.patientId?.id),
                      trackingCode: String(modalInfo?.item?.sakhadTrackingCode),
                      tajvizType: "6",
                    };
                    downloadPrescriptionFile.mutate(reqBody);
                  }}
                >
                  <Icon name="file-download" />
                  <p className="d-flex text-hover mx-2 font-14 fw-semibold cur-pointer">
                    دانلود نسخه فیزیوتراپی
                  </p>
                </span>
              </div>
            </>
          ) : (
            <div className="py-5">
              <EmptyBox content="اطلاعاتی برای این نسخه یافت نشد" />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  modalData: modalDataSelector(state),
  modalName: modalNameSelector(state),
  isShowModalData: isShowModalDataSelector(state),
  isHideModalData: isHideModalDataSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  handleHideModal: () => dispatch(general.handleHideModal()),
  handleResetModal: () => dispatch(general.handleResetModal()),
  handleShowModal: (data: any, body: any) =>
    dispatch(general.handleShowModal(data, body)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShowPatientSakhadVisitModal);
